var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"height":"100%"}},[_c('div',{staticClass:"back-to"},[_c('span',{staticClass:"text",on:{"click":_vm.onNavTo}},[_vm._v("返回")])]),_c('keep-alive',[_c('router-view',{staticStyle:{"height":"100%"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }